import { IAPIRoutes } from "../../../../config";

export type ISMSRepositoryType = ReturnType<typeof SMSRepositoryFactory>;

export const SMSRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST, GET } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const sendOTP: ISendOTPAPI = async (payload) => {
    const response = await POST(
      APIRoutes.apiSendOTP,
      {
        phone_number: payload.phoneNumber,
      },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
    return response;
  };

  const verifyOTP: IVerifyOTPAPI = async (payload) => {
    const response = await POST(
      APIRoutes.apiVerifyOTP,
      {
        otp: payload.otp,
        unique_request_id: payload.uniqueRequestId,
      },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
    return response;
  };

  const saveNumber: ISaveNumberAPI = async (payload) => {
    const response = await POST(
      APIRoutes.apiSavePhoneNumber,
      {
        phone_number: payload.phoneNumber,
      },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
    return {
      data: response,
      success:
        response.message ===
        "User's phone number is saved for sms notifications",
    };
  };

  const getPhoneNumber: IGetPhoneNumberAPI = async () => {
    try {
      const response = await GET(
        APIRoutes.apiSavePhoneNumber,
        {},
        { Authorization: `Bearer ${await getAuthenticationToken()}` }
      );
      return {
        phoneNumber: response.phone_number,
        isVerified: response.is_verified,
      };
    } catch (error) {
      return {
        phoneNumber: "",
        isVerified: false,
      };
    }
  };

  return {
    sendOTP,
    verifyOTP,
    saveNumber,
    getPhoneNumber,
  };
};
